import React, {useEffect, useState} from "react";
import "./style.scss";
import verif from "../../../../assets/images/verif.jpg";
import sumsuberIcon from "../../../../assets/icons/sumsuberIcon.webp";
import warningSvg from "../../../../assets/icons/warning.svg";
import verifySvg from "../../../../assets/icons/verifyNowIcon.svg";
import unverifiedSvg from "../../../../assets/icons/unverifiedIcon.svg";
import {getSumsubStatusReq, loadUser} from "../../../../utils/apis/user";
import {useSelector} from "react-redux";
import SumsubModal from "../SumsubModal";

function VerifyNow({kycStatus, openVerificationModal}) {
  const [isVerifyVisible, setIsVerifyVisible] = useState(false);
  const idToken = useSelector((state) => state.auth.idToken);
  const accountListRedux = useSelector((state) => state.account.accountList.data);
  const [accountCount, setAccountCount] = useState(accountListRedux);
  useEffect(() => {
    setAccountCount(accountListRedux);
  }, [accountListRedux]);
  const [open, setOpen] = useState(false);
  const [kycSTatus, setKycStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const getSumsubStatus = async () => {
    setLoading(true);
    try {
      const response = await getSumsubStatusReq(idToken);
      setKycStatus(response.data);
    } catch (error) {
      console.error("Error fetching access token:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="verifynow">
      <div className={`verifynow_container ${kycSTatus?.is_verified === true ? "verifiedKYC" : "notVerifiedKYC"}`}>
        <div className="kycStatusIndicator">
          <p>{kycSTatus?.is_verified === true ? <p>Verified</p> : <p>Unverified</p>}</p>
        </div>
        <div className="verifynow_header">
          <div className="iconBox">
            <img
              src={sumsuberIcon}
              alt=""
            />
            <p>Sumsub</p>
          </div>
          {kycSTatus?.is_verified && kycSTatus?.detail === "KYC is already verified on Veriff" ? (
            <div className="verificationStatusContainer">
              <p className="verifiedTag">Verified</p>
            </div>
          ) : (
            <div className="verificationStatusContainer">
              <button
                className="verifiedNowBtn"
                style={{cursor: "pointer"}}
                onClick={() => setOpen(true)}
              >
                Verify Now
              </button>
            </div>
          )}
        </div>
        <div className="verifynow_details">
          <h4>One verification platform to secure the whole user journey. Secure every step of the your customer journey.</h4>
          <div className="verifynow_details_warning">
            <div className="verifynow_details_warning_header">
              <img
                src={warningSvg}
                style={{opacity: "1 !important"}}
                alt=""
              />{" "}
              <p>In order to complete, upload and avoid delays when verifying account. Please make sure below:</p>
            </div>
            <div className="details_container">
              <ul className="verify_now_details_warning_list">
                <li>Chosen credential must not be expired.</li>
                <li>Documents should be good condition and clearly visible.</li>
                <li>Make sure that there is no light glare on the card.</li>
              </ul>

              <SumsubModal
                open={open}
                sumHandleClose={() => setOpen(() => false)}
                kycStatus={kycStatus}
                getSumsubStatus={getSumsubStatus}
                setOpen={setOpen}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VerifyNow;
